<script>
    export let user;
    import AxAppMenu from './AxAppMenu.svelte'
    let tab=undefined;
</script>

<AxAppMenu on:change={(e)=>{tab=e.detail.value}}/>
{#if tab=="activities"}
    
{:else if tab=="user"}

{:else if tab=="config"}

{/if}